module.exports = __webpack_public_path__ + "static/img/icon3.b1bfdc41.svg";